$(document).on('focus', '.js-google-places-autocomplete', function () {
  let pac = $('.pac-container'),
    arr = [];
  pac.each(function () {
    arr.push($(this));
  });
  $(this).closest('.form-item-wrap').append(arr);
});
